import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import Fairness from '../fairness';
import GameRules from '../gameRules';
import Calculator from '../calculator';
import { popupStore } from '../../store/popupStore';
import { PopupTypes } from '../../core/constants/popupTypes';
import PopupTitle from './title';
import CloseIcon from './closeIcon';
import BackIcon from './backIcon';
import HotKeysWrapper from '../../containers/hotKeysWrapper';
import { useOutSideClick } from '../../hooks/useOutSideClick';
import { checkHashStore } from '../../store/checkHashStore';
import { TranslationKeys } from '../../core/constants/translationKeys';
import AboutHash from '../fairness/aboutHash';
import useTranslation from '../../hooks/useTranslation';
import './popup.scss';
import { DepositPopup } from '../depositPopup';

const Popup = observer(() => {
  const { popupName, close, popupBack, setRoundInfo } = popupStore;
  const [popupRef, isOutSideClick] = useOutSideClick();
  const t = useTranslation();

  const popupMap = useMemo(() => {
    return {
      [PopupTypes.Fairness]: {
        component: <Fairness />,
        title: TranslationKeys.ProvablyFairness,
        isShowBackIcon: false,
        isBlur: false,
      },
      [PopupTypes.AboutHash]: {
        component: <AboutHash />,
        title: TranslationKeys.AboutHash,
        isShowBackIcon: false,
        isBlur: false,
      },
      [PopupTypes.Calculator]: {
        component: <Calculator />,
        title: TranslationKeys.Calculator,
        isShowBackIcon: true,
        isBlur: false,
      },
      [PopupTypes.GameRules]: {
        component: <GameRules />,
        title: TranslationKeys.GameRules,
        isShowBackIcon: false,
        isBlur: true,
      },
      [PopupTypes.HotKeys]: {
        component: <HotKeysWrapper />,
        title: TranslationKeys.HotKeys,
        isShowBackIcon: false,
        isBlur: false,
      },
      [PopupTypes.Deposit]: {
        component: <DepositPopup />,
        title: TranslationKeys.DepositNow,
        isCustom: true,
      },
    };
  }, []);

  useEffect(() => {
    return () => {
      checkHashStore.resetCalculateSaltAndKey();
    };
  }, []);

  useEffect(() => {
    if (isOutSideClick) {
      close();
      checkHashStore.resetSpinInfo();
      setRoundInfo(null);
    }
  }, [isOutSideClick, close, setRoundInfo]);

  return (
    <div className='cpt-container-pp'>
      <style>{`:root{--scroll: hidden}`}</style>
      {popupMap[popupName].isCustom ? (
        popupMap[popupName].component
      ) : (
        <div
          className={`cpt-pp-wrp ${popupName} ${popupMap[popupName].isBlur ? 'blur' : ''}`}
          ref={popupRef}
        >
          <div className='cpt-icon-title-block'>
            <CloseIcon
              handleClick={() => {
                checkHashStore.resetSpinInfo();
                close();
              }}
            />
            {popupMap[popupName].isShowBackIcon && <BackIcon handleClick={popupBack} />}
            <PopupTitle text={t(popupMap[popupName].title)} />
          </div>
          {popupName === 'AboutHash' && (
            <div className='cpt-bac-box' onClick={() => popupStore.popupBack()}>
              <i className='icon-back cpt-back-i' />
            </div>
          )}
          <div className='cpt-scroll-holder'>
            <div className='cpt-scrollable-container'>{popupMap[popupName].component}</div>
          </div>
        </div>
      )}
    </div>
  );
});

export default Popup;
